var _line, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 10,
    viewBox: "0 0 144 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4.75,
    x2: 143,
    y2: 4.75,
    stroke: "#00F981",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#00F981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 5L136.5 9.33013L136.5 0.669872L144 5Z",
    fill: "#00F981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapArrow);
export default __webpack_public_path__ + "static/media/roadmap-arrow.cadcb648001ca37d6e55fb46847d9885.svg";
export { ForwardRef as ReactComponent };